<id-footer-inera-admin headline="Klientadministration" class="ids-hide ids-show-inera-admin" type="inera-admin">
  <id-link slot="link-col-1">
    <a
      href="https://inera.atlassian.net/wiki/spaces/ST/pages/4930568336/Tillg+nglighet+f+r+IdP+Plus+och+Klientadministration"
      title="Tillgänglighet">
      <span class="ids-icon-arrow-right-small ids-icon--text-start" aria-hidden="true"></span>
      Tillgänglighet
    </a>
  </id-link>

  <id-link slot="link-col-1">
    <a href="https://www.inera.se/kontakta-oss/" title="Kontakt">
      <span class="ids-icon-arrow-right-small ids-icon--text-start" aria-hidden="true"></span>
      Kontakta Inera
    </a>
  </id-link>

  <p slot="sub-footer-right">
    Klientadministration drivs av
    <id-link [small]="true" [underlined]="true" [colorpreset]="3">
      <a href="#">
        <span>
          Inera AB
          <span class="ids-icon-external-link-small ids-icon--text-end" aria-hidden="true"></span>
        </span>
      </a>
    </id-link>
    på uppdrag av Sveriges regioner
  </p>

  <p slot="sub-footer-mobile">
    Klientadministration drivs av
    <id-link [small]="true" [underlined]="true" [colorpreset]="3">
      <a href="#">
        <span>
          Inera AB
          <span class="ids-icon-external-link-small ids-icon--text-end" aria-hidden="true"></span>
        </span>
      </a>
    </id-link>
    på uppdrag av Sveriges regioner
  </p>
</id-footer-inera-admin>
